export default __webpack_public_path__ + "static/media/LabCard.53d34bf7.webp";